import { 
	FILES_DROPPED,
	FILES_CLEAR,
	FILES_CLEAR_ONE,
	FILES_ADD_KEYWORD,
	FILES_REMOVE_KEYWORD,
	FILES_ENABLE_UPLOAD,
	FILES_DISABLE_UPLOAD,
	FILES_UPLOAD_STARTED,
	FILES_UPLOAD_CANCELLED,
	FILES_UPLOAD_COMPLETED,
	FILES_UPDATE_FIELD,
	FILES_META_LOADED,
	FILES_META_ERROR,
	FILES_META_SHOW,
	FILES_META_HIDE,
	FILES_SAVE_TEMP_PATH,
	FILES_SHOW_SUGGESTION,
	FILES_SUGGESTION_SHOW,
	FILES_SUGGESTION_HIDE,
	FILES_META_MERGE,
	FILES_FETCHED_IMAGE_SUGGESTIONS,
	FILES_FETCHING_IMAGE_SUGGESTIONS,
	FILES_FETCH_ERROR_IMAGE_SUGGESTIONS,
	FILES_HIDE_IMAGE_SUGGESTION_MODAL
} from 'constants/actiontypes';

import keywords from 'reducers/filekeywords';

const INITIAL_STATE = {
	keywords: [],
	caption: '',
	exif_caption: '',
	description: '',
	credit: '',
	credit_link: '',
	meta: {},
	added: false,
	suggested: [],
	metaLoaded: false,
	metaError: false,
	metaShow: false,
	uploaded: false,
	uploading: false,
	suggestedKeywords: [],
	errors: {
		keywords: false,
		credit: false,
		exif_caption: false,
		caption: false
	},
	suggestedImages: [],
	fetchingSuggested: false,
	fetchedSuggested: false,
	fetchSuggestedError: false,
	name: 'tmp.jpg',
	uploadEnabled: true,
	showModal: false,
	file: {},
	imagePath: '',
};

const fileselector = (state=INITIAL_STATE, action) => {
	switch (action.type) {
		case FILES_DROPPED:
			const file = action.files[0];
			return Object.assign({}, state, {
				keywords: [],
				exif_caption: '',
				caption: '',
				description: '',
				credit: '',
				credit_link: '',
				imagePath: '',
				added: true,
				suggested: action.suggested || [],
				suggestedKeywords: action.keywords || [],
				suggestedImages: [],
				meta: {},
				errors: {
					keywords: false,
					credit: false,
					exif_caption: false,
					caption: false
				},
				name: file.name,
				showModal: false,
				file,
			});

		case FILES_CLEAR_ONE:
			return INITIAL_STATE;

		case FILES_CLEAR:
			return INITIAL_STATE;

		case FILES_ENABLE_UPLOAD:
			return Object.assign({}, state, {
				uploadEnabled: true,
			});

		case FILES_DISABLE_UPLOAD:
			return Object.assign({}, state, {
				uploadEnabled: false,
			});

		case FILES_UPLOAD_STARTED:
			return Object.assign({}, state, { uploading: true });

		case FILES_UPLOAD_CANCELLED:
			const modData = {
				uploading: false,
				uploaded: false
			};
			if (action.errors) {
				modData.errors = Object.assign({
					keywords: false,
					exif_caption: false,
					caption: false,
					credit: false,
				}, action.errors);
			}
			return Object.assign({}, state, modData);

		case FILES_UPLOAD_COMPLETED:
			return Object.assign({}, state, {
				uploading: false,
				uploaded: true,
				file: action.file,
				errors: {}
			});

		case FILES_SAVE_TEMP_PATH:
			if (action.imagePath && action.imagePath !== '') {
				return Object.assign({}, state, {
					imagePath: action.imagePath,
				});
			}
			return state;

		case FILES_ADD_KEYWORD:
		case FILES_REMOVE_KEYWORD:
			return Object.assign({}, state, {
				keywords: keywords(state.keywords, action)
			});

		case FILES_UPDATE_FIELD:
			return Object.assign({}, state, {
				[action.name]: action.value,
			});

		case FILES_META_LOADED:
			return Object.assign({}, state, {
				metaLoaded: true,
				metaError: false,
				meta: JSON.parse(JSON.stringify(action.data)),
			});

		case FILES_META_ERROR:
			return Object.assign({}, state, {
				metaLoaded: false,
				metaError: true,
				meta: {}
			});

		case FILES_META_SHOW:
			if (!state.metaLoaded) {
				return state
			}
			return Object.assign({}, state, {
				metaShow: true
			});

		case FILES_META_HIDE:
			if (!state.metaLoaded) {
				return state;
			}
			return Object.assign({}, state, {
				metaShow: false,
			});

		case FILES_SUGGESTION_SHOW:
			if (state.suggestedKeywords.length < 1 || state.showSuggestedKeywords == true) {
				return state;
			}
			return Object.assign({}, state, {
				showSuggestedKeywords: true,
			});

		case FILES_SUGGESTION_HIDE:
			if (state.suggestedKeywords.length < 1 || state.showSuggestedKeywords == false) {
				return state;
			}
			return Object.assign({}, state, {
				showSuggestedKeywords: false,
			});

		case FILES_META_MERGE:
			if (action.data.keywords) {
				action.data.keywords = keywords(state.keywords, {
					type: FILES_ADD_KEYWORD,
					keywords: action.data.keywords,
				});
			}
			if (state.imagePath && state.imagePath === '' && action.data.filename) {
				action.data.imagePath = action.filename;
				delete action.data.filename;
			}
			const res = Object.assign({}, state, action.data);
			return res;

		case FILES_FETCHED_IMAGE_SUGGESTIONS:
			return Object.assign({}, state, {
				suggestedImages: action.images,
				fetchedSuggested: true,
				fetchingSuggested: false,
				fetchSuggestedError: false,
				imagePath: action.imagePath || '',
				showModal: true,
			});

		case FILES_FETCHING_IMAGE_SUGGESTIONS:
			return Object.assign({}, state, {
				fetchedSuggested: false,
				fetchingSuggested: true,
				fetchSuggestedError: false,
				showModal: false,
			});

		case FILES_FETCH_ERROR_IMAGE_SUGGESTIONS:
			return Object.assign({}, state, {
				suggestedImages: [],
				fetchedSuggested: false,
				fetchingSuggested: false,
				fetchSuggestedError: true,
				showModal: false,
			});
		case FILES_HIDE_IMAGE_SUGGESTION_MODAL:
			return Object.assign({}, state, {
				showModal: false,
			});
		default:
			return state;
	}
};

export default fileselector;



/** WEBPACK FOOTER **
 ** ./reducers/fileselector.js
 **/